<template>
  <div v-if="order">
    <v-card v-if="manifests" flat>
      <v-card-text>
        <v-tabs
          v-model="selectedTab"
          align-with-title
          background-color="blue-grey lighten-4"
          show-arrows
        >
          <v-tabs-slider />
          <v-tab
            v-for="orderDetail in manifests"
            :key="orderDetail.key"
          >
              {{ orderDetail.item_name }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item
            v-for="(orderDetail) in manifests"
            :key="orderDetail.key"
          >
            <v-card-title>
              <span style="color: #0074BA">廃棄物情報</span>&emsp;
              <v-btn
                v-if="canShowEditButton && !orderDetail.already_registered"
                small
                @click="enableWasteDialogButtonClickEvent(orderDetail)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
                &nbsp;編集
              </v-btn>
              &nbsp;
              <v-chip
                v-if="!['before_reserve', 'none_use_approval'].includes(orderDetail.approval_status)"
                middle
                label
                :color="orderDetail.approval_status | approval_status_chip_color(orderDetail.manifest_registered)"
              >
                {{ orderDetail.approval_status | approval_status_chip_label(orderDetail.manifest_registered) }}
              </v-chip>

            </v-card-title>
            <v-card-text>
              <!-- マニフェスト番号 -->
              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    マニフェスト番号
                  </div>
                  <h4>{{ orderDetail.manifest_no || '-' }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    起票支店/営業所名
                  </div>
                  <h4>{{ orderDetail.tenant_name || '-' }}</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /マニフェスト番号 -->
              <!-- 判定日時・排出差戻理由 -->
              <v-row
                v-if="orderDetail.level === 'first_manifest' && orderDetail.manifest_type === 'dxe_form' && orderDetail.approval_status !== 'none_use_approval'"
              >
                <v-col cols="12" md="6">
                  <div class="overline">
                    排出判定日時
                  </div>
                  <h4 v-if="orderDetail.approval_judgment_at">
                    {{ orderDetail.approval_judgment_at | unix_datetime_format }}&nbsp;
                  </h4>
                  <h4 v-else>
                    -
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    排出差戻理由
                  </div>
                  <h4 class="red--text">
                    {{ orderDetail.approval_remand_reason || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /判定日時・排出差戻理由 -->

              <!-- 売上品目 -->
              <v-row
                v-if="order.form_type === 'master_mode'"
              >
                <v-col cols="12" md="6" v-if="isBilling && orderDetail.manifest_type !== 'general_form'">
                  <div class="overline">
                    売上品目
                  </div>
                  <h4>{{ orderDetail.waste_information.sales_item_price_code }} : {{ orderDetail.waste_information.sales_item_price_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    取扱品目
                  </div>
                  <h4>{{ orderDetail.waste_information.item_code }} : {{ orderDetail.waste_information.item_name }}</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /売上品目 -->
              <!-- 廃棄物の名称／数量・数量の確定者 -->
              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    廃棄物の名称
                  </div>
                  <h4>{{ orderDetail.waste_information.waste_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    数量
                  </div>
                  <h4>{{ orderDetail.waste_information.quantity || '-' }}&nbsp;{{ orderDetail.waste_information.quantity_unit_name || '-' }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    数量の確定者
                  </div>
                  <h4>{{ orderDetail.waste_information.quantity_confirm_name || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- 廃棄物の名称／数量・数量の確定者 -->
              <!-- 荷姿 -->
              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    荷姿
                  </div>
                  <h4>{{ orderDetail.waste_information.packing_name || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    荷姿の数量
                  </div>
                  <h4>{{ orderDetail.waste_information.packing_quantity || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /荷姿 -->
              <!-- 有害物質 -->
              <template v-if="hasHazardousSubstance(orderDetail)">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="overline">
                    有害物質１
                  </div>
                  <h4>{{ orderDetail.waste_information.hazardous_substance_1_name || '-' }}</h4>
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="overline">
                    有害物質２
                  </div>
                  <h4>{{ orderDetail.waste_information.hazardous_substance_2_name || '-' }}</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="overline">
                    有害物質３
                  </div>
                  <h4>{{ orderDetail.waste_information.hazardous_substance_3_name || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="overline">
                    有害物質４
                  </div>
                  <h4>{{ orderDetail.waste_information.hazardous_substance_4_name || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="overline">
                    有害物質５
                  </div>
                  <h4>{{ orderDetail.waste_information.hazardous_substance_5_name || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="overline">
                    有害物質６
                  </div>
                  <h4>{{ orderDetail.waste_information.hazardous_substance_6_name || '-' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              </template>
              <!-- /有害物質 -->
            </v-card-text>

            <!-- 連絡番号１／連絡番号２／連絡番号３ -->
            <v-card-title>
              <span style="color: #0074BA">連絡番号</span>&emsp;
              <v-btn
                v-if="canShowEditButton && !orderDetail.already_registered"
                small
                @click="enableContactNumberDialogButtonClickEvent(orderDetail)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
                &nbsp;編集
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    連絡番号１
                  </div>
                  <h4>
                    {{ orderDetail.contact_number.contact_number_1 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    連絡番号２
                  </div>
                  <h4>
                    {{ orderDetail.contact_number.contact_number_2 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    連絡番号３
                  </div>
                  <h4>
                    {{ orderDetail.contact_number.contact_number_3 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /連絡番号１／連絡番号２／連絡番号３ -->
            </v-card-text>

            <!-- 備考１／備考２／備考３／備考４／備考５ -->
            <v-card-title>
              <span style="color: #0074BA">JWNET備考</span>&emsp;
              <v-btn
                v-if="canShowEditButton && !orderDetail.already_registered"
                small
                @click="enableTransportNoteDialogButtonClickEvent(orderDetail)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
                &nbsp;編集
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    備考１
                  </div>
                  <h4>
                    {{ orderDetail.transport_note.note_1 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    備考２
                  </div>
                  <h4>
                    {{ orderDetail.transport_note.note_2 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    備考３
                  </div>
                  <h4>
                    {{ orderDetail.transport_note.note_3 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    備考４
                  </div>
                  <h4>
                    {{ orderDetail.transport_note.note_4 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    備考５
                  </div>
                  <h4>
                    {{ orderDetail.transport_note.note_5 || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /備考１／備考２／備考３／備考４／備考５ -->
            </v-card-text>

            <h2>運搬詳細</h2>

            <v-card-title>
              <span style="color: #0074BA">運搬ルート</span>&emsp;
              <v-btn
                v-if="canShowEditButton && !orderDetail.already_registered"
                small
                @click="enableDisposerLocationDialogButtonClickEvent(orderDetail)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
                &nbsp;編集
              </v-btn>
            </v-card-title>
            <v-card-text>
              <!-- ルート名/処分方法 -->
              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    ルート名
                  </div>
                  <h4>
                    {{ orderDetail.transport_route.name || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    処分方法
                  </div>
                  <h4>
                    {{ orderDetail.transport_route.disposal_method_name || '-' }}&nbsp;
                  </h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ルート名/処分方法 -->

              <!-- ルート詳細 -->
              <transport-route-result
                :custom-mode="true"
                :form="orderDetail"
                :transport-route-id="orderDetail.transport_route?.id"
                :emission="order.emission"
              />
              <!-- /ルート詳細 -->
            </v-card-text>

            <!-- 再資源化等処理情報 -->
            <v-row
              v-if="orderType !== 'general' && (mode === 'transport_disposal' || mode === 'disposal')"
            >
              <v-col
                cols="12"
              >
                <v-card
                  flat
                  class="rounded-card"
                >
                  <v-card-title>
                    <span style="color: #0074BA">再資源化等処理情報​</span>&emsp;
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          基準重量
                        </div>
                        <h4>
                          {{ orderDetail.recycle_disposal.standard_quantity_type_name || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          処分場処理方法
                        </div>
                        <h4>
                          {{ orderDetail.recycle_disposal.recycle_disposer_disposal_method_name || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- ／再資源化等処理情報 -->

            <!-- 運搬完了報告 -->
            <transport-complete-report :manifest="orderDetail"  />
            <!-- /運搬完了報告 -->

            <!-- 運搬終了報告 1〜５-->
            <transport-report-result :manifest-transports="orderDetail.manifest_transports" />
            <!-- /運搬終了報告 1〜５-->

            <!-- 処分報告 -->
            <v-row>
              <v-col
                cols="12"
              >
                <v-card
                  flat
                  class="rounded-card"
                >
                  <v-card-title>
                    <span style="color: #0074BA">処分報告</span>&emsp;
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          報告区分
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_type_name }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          処分終了日
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_end_date || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          処分担当者
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_person || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          報告担当者
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_reporter || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          廃棄物受領日
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_receipt_date || '-' }}&nbsp;&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          運搬担当者
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_driver || '-' }}&nbsp;&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          車両番号
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_vehicle_number || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          受入量
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_amount }}&nbsp;{{ orderDetail.disposal_report.disposal_report_amount_unit_name }}
                        </h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          処分終了報告日時
                        </div>
                        <h4 v-if="orderDetail.disposal_report.disposal_end_at">
                          {{ orderDetail.disposal_report.disposal_end_at | unix_datetime_format }}&nbsp;
                        </h4>
                        <h4 v-else>
                          -&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          最終処分終了日
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_end_last_date || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                      <v-col cols="12" md="3">
                        <div class="overline">
                          最終処分終了報告日時
                        </div>
                        <h4 v-if="orderDetail.disposal_report.final_disposal_end_at">
                          {{ orderDetail.disposal_report.final_disposal_end_at }}&nbsp;
                        </h4>
                        <h4 v-else>
                          -
                        </h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="overline">
                          処分備考
                        </div>
                        <h4>
                          {{ orderDetail.disposal_report.disposal_report_remarks || '-' }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- /処分報告 -->
                  <!-- 最終処分 -->
                  <v-card-title>
                    <span style="color: #0074BA">最終処分</span>&emsp;
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="tableHeaders"
                      :items="orderDetail.final_disposals"
                      disable-sort
                      hide-default-footer
                      no-data-text=" "
                    >
                      <template v-slot:[`item.name`]="{item}">
                        {{ item.name }}
                        <v-tooltip
                          top
                          :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn
                              v-if="item.address"
                              icon
                              small
                              retain-focus-on-click
                              @click="on.click"
                              @blur="on.blur"
                            >
                              <v-icon small>
                                mdi-map-marker-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <small
                            v-if="item.address"
                          >
                            {{ item.address }}
                          </small>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <!-- /最終処分 -->

                  <!-- 再資源化等の情報詳細 -->
                  <template v-if="showRecycleDisposalReport(orderDetail)">
                    <v-card-title>
                      <span style="color: #0074BA">再資源化等の情報詳細</span>
                    </v-card-title>
                    <v-card-text>
                      <!-- 基準重量・数量 -->
                      <v-row>
                        <v-col cols="12" md="3">
                          <div class="overline">
                            基準重量
                          </div>
                          <h4>
                            {{ orderDetail.reported_standard_quantity_type_name || '-' }}&nbsp;
                          </h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="3">
                          <div class="overline">
                            重量
                          </div>
                          <h4>
                            {{ orderDetail.reported_quantity ? `${orderDetail.reported_quantity}kg` : '-' }}
                          </h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /基準重量・重量 -->
                      <div class="mt-2">
                        <recycle-step-table
                          :headers="headers"
                          :result-list="orderDetail.manifest_recycle_disposal_reports || []"
                          :reference-only="true"
                        />
                      </div>
                    </v-card-text>
                  </template>
                  <!-- /再資源化等の情報詳細 -->

                  <!-- マニフェスト検索キーワード -->
                  <v-card-title>
                    <span style="color: #0074BA">マニフェスト検索キーワード</span>&emsp;
                    <edit-manifest-search-keyword-dialog
                      :manifest-id="orderDetail.id"
                      @registerCallback="dialogRegisterCallBack"
                    />
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <div class="overline" style="text-transform: none">
                          マニフェスト検索キーワード&nbsp;
                          <span class="red--text font-weight-bold">&emsp;※&nbsp;DXEStation排出モードにも表示されます。&nbsp;</span>
                        </div>
                        <h4>
                          {{ orderDetail.manifest_search_keyword }}&nbsp;
                        </h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- /マニフェスト検索キーワード -->
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <edit-waste-dialog
      :enable-dialog="enableWasteDialog"
      :order-id="order.id"
      :manifest-id="targetManifestId"
      :packings="packings"
      :quantity-units="quantityUnits"
      :quantity-confirms="quantityConfirms"
      :hazardous-substances="hazardousSubstances"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-contact-number-dialog
      :order-id="order.id"
      :manifest-id="targetManifestId"
      :enable-dialog="enableContactNumberDialog"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-transport-note-dialog
      :order-id="order.id"
      :manifest-id="targetManifestId"
      :enable-dialog="enableTransportNoteDialog"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-transaction-location-dialog
      :enable-dialog="enableTransportLocationDialog"
      :order-id="order.id"
      :order="order"
      :manifest-id="targetManifestId"
      :transportations="transportations"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-disposer-location-dialog
      :enable-dialog="enableDisposerLocationDialog"
      :order-id="order.id"
      :order="order"
      :manifest-id="targetManifestId"
      :disposal-methods="disposalMethods"
      :order-type="orderType"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
  </div>
</template>

<script>

import TransportRouteResult from "../../../../../components/TransportRouteResult";
import EditWasteDialog from '../dialogs/_EditWasteDialog'
import EditContactNumberDialog from '../dialogs/_EditContactNumberDialog'
import EditTransportNoteDialog from '../dialogs/_EditTransportNoteDialog'
import EditTransactionLocationDialog from '../dialogs/_EditTransportLocationDialog'
import EditDisposerLocationDialog from '../dialogs/_EditDisposerLocationDialog'
import TransportCompleteReport from '../../../../../components/TransportCompleteReport'
import TransportReportResult from '../../../../../components/TransportReportResult'
import { mapState } from 'vuex'
import EditManifestSearchKeywordDialog from '../../../../manifest/managements/dialogs/_EditManifestSearchKeywordDialog'

export default {
  name: 'OrderSalesItemBlock',
  components: {
    TransportRouteResult,
    EditWasteDialog,
    EditContactNumberDialog,
    EditTransportNoteDialog,
    EditTransactionLocationDialog,
    EditDisposerLocationDialog,
    TransportCompleteReport,
    TransportReportResult,
    EditManifestSearchKeywordDialog
  },
  mixins: [],
  props: {
    order: {
      type: Object,
      default: () => null,
    },
    canShowEditButton: {
      type: Boolean,
      default: () => false,
    },
    packings: {
      type: Array,
      default: () => [],
    },
    quantityUnits: {
      type: Array,
      default: () => [],
    },
    quantityConfirms: {
      type: Array,
      default: () => [],
    },
    hazardousSubstances: {
      type: Array,
      default: () => [],
    },
    transportations: {
      type: Array,
      default: () => [],
    },
    disposalMethods: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    orderType: {
      type: String,
      default: 'collection'
    },
  },
  data() {
    return {
      tableHeaders: [
        { value: 'final_disposal_date', text: '最終処分終了日' },
        { value: 'name', text: '最終処分事業場' }
      ],
      order_id: null,
      enableWasteDialog: false,
      enableContactNumberDialog: false,
      enableTransportNoteDialog: false,
      enableTransportLocationDialog: false,
      enableDisposerLocationDialog: false,
      manifests: null,
      selectedTab: null,
      targetManifestId: null,
      headers: [
        {value: "level", text: "工程", width: "5%"},
        {value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "20%"},
        {value: "report_before_disposal_weight", text: "処分前\r\n重量", width: "7%"},
        {value: "disposal_method", text: "処分方法", width: "18%"},
        {value: "report_after_disposal_weight", text: "処理後\r\n重量", width: "7%"},
        {value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "18%"},
        {value: "final_disposal", text: "最終処分", width: "10%"},
        {value: "input_final_disposal_date", text: "最終処分終了日", width: "8%"},
        {value: "comment", text: "備考", width: "7%"},
      ]
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      mode: 'mode',
    }),
  },
  watch: {
    order (newValue) {
      this.order_id = newValue.id
      if (newValue) {
        this.manifests = this.order.manifests
      }
      console.log('watch:', this.manifests)
    },

  },
  created() {

    this.manifests = this.order?.manifests
    console.log('created:', this.manifests)
    this.selectedTab = 0
  },
  methods: {
    /**
     * 有害物質を表示するかどうかを判定
     * @param orderDetail マニフェスト詳細
     * @return {boolean} true: 表示する, false: 非表示
     */
    hasHazardousSubstance(orderDetail) {
      if (!orderDetail || !orderDetail.item_id) {
        return false;
      }
      const item = this.items.find(v => v.value === orderDetail.item_id);
      if (!item) {
        return false;
      }
      return item.use_harmful;
    },
    /**
     * 再資源化等の情報詳細を表示するかどうかを判定
     * @param orderDetail マニフェスト詳細
     * @return {boolean} true: 表示する, false: 非表示
     */
    showRecycleDisposalReport(orderDetail) {
      return (this.mode === 'transport_disposal' || this.mode === 'disposal') && orderDetail.manifest_recycle_disposal_reports.some(
        report => ['last_report', 'final_disposal_report'].includes(report.report_type)
      )
    },
    enableWasteDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableWasteDialog = true
    },
    enableContactNumberDialogButtonClickEvent(manifest) {
      this.targetManifestId = manifest.id
      this.enableContactNumberDialog = true
    },
    enableTransportNoteDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableTransportNoteDialog = true
    },
    enableTransportLocationDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableTransportLocationDialog = true
    },
    enableDisposerLocationDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableDisposerLocationDialog = true
    },
    /**
     * ダイアログを閉じる処理
     */
    dialogCloseCallback () {
      this.enableWasteDialog = false
      this.enableContactNumberDialog = false
      this.enableTransportNoteDialog = false
      this.enableTransportLocationDialog = false
      this.enableDisposerLocationDialog = false
    },
    /**
     * ダイアログ上での登録処理完了後のコールバック処理
     * ダイアログを閉じ、再取得を行う.
     */
    dialogRegisterCallBack () {
      this.dialogCloseCallback()
      this.$emit('refreshDetail')
    },
  }
}
</script>

<style scoped lang="scss">

</style>
